export function isTokenExpired(token) {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const now = Math.floor(Date.now() / 1000);
    return payload.exp < now;
  } catch (err) {
    return true;
  }
}

export function formatTitle(title) {
  if (!title || typeof title !== 'string') return title;
  return title
    .replace(/-/g, ' ') // Replace hyphens with spaces
    .split(' ') // Split by spaces
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter of each word
    .join(' '); // Join back with spaces
}

export function categoryToUrl(categoryName) {
  if (!categoryName || typeof categoryName !== 'string') return '';

  return categoryName
    .toLowerCase()
    .replace(/&/g, '%26') // Replace & with URL-encoded %26
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/[^a-z0-9%-]/g, '') // Remove any other special characters except letters, numbers, hyphens, and %
    .replace(/-+/g, '-') // Replace multiple consecutive hyphens with single hyphen
    .replace(/^-|-$/g, ''); // Remove leading and trailing hyphens
}

export function urlToCategory(urlCategory) {
  if (!urlCategory || typeof urlCategory !== 'string') return '';

  return urlCategory
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export function decodeHtmlEntities(text) {
  if (!text || typeof text !== 'string') return text;

  const textarea = document.createElement('textarea');
  let decoded = text;

  // Decode multiple times to handle double-encoded entities
  let previousDecoded;
  let iterations = 0;
  const maxIterations = 3; // Prevent infinite loops

  do {
    previousDecoded = decoded;
    textarea.innerHTML = decoded;
    decoded = textarea.value;
    iterations++;
  } while (decoded !== previousDecoded && iterations < maxIterations);

  // Handle &apos; which may not be decoded by innerHTML
  decoded = decoded.replace(/&apos;/g, "'");

  return decoded;
}

export function decodeHtmlForRendering(text) {
  if (!text || typeof text !== 'string') return text;

  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  let decoded = textarea.value;

  // Handle escape sequences for line breaks
  // Replace literal \r\n, \n, and \r with HTML line breaks
  decoded = decoded
    .replace(/\\r\\n/g, '<br />')
    .replace(/\\n/g, '<br />')
    .replace(/\\r/g, '<br />')
    // Also handle actual newline characters (in case they exist)
    .replace(/\r\n/g, '<br />')
    .replace(/\n/g, '<br />')
    .replace(/\r/g, '<br />')
    // Handle other common escape sequences
    .replace(/\\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;') // Tab to 4 spaces
    .replace(/\\"/g, '"') // Escaped quotes
    .replace(/\\'/g, "'"); // Escaped single quotes

  return decoded;
}

export function getSafeRedirectPath(redirectTo, fallback = '/') {
  if (!redirectTo || typeof redirectTo !== 'string') return fallback;
  if (!redirectTo.startsWith('/') || redirectTo.startsWith('//'))
    return fallback;
  if (redirectTo === '/login' || redirectTo.startsWith('/login?'))
    return fallback;
  return redirectTo;
}

export function getLoginPath(redirectTo = '/') {
  const safeRedirectTo = getSafeRedirectPath(redirectTo);
  return `/login?redirect=${encodeURIComponent(safeRedirectTo)}`;
}

export function navigateToLogin(
  navigate,
  redirectTo = '/',
  redirectState = null,
) {
  const safeRedirectTo = getSafeRedirectPath(redirectTo);
  navigate(getLoginPath(safeRedirectTo), {
    state: { redirectTo: safeRedirectTo, redirectState },
  });
}

export function getRedirectStateAfterLogin(location) {
  return location?.state?.redirectState || null;
}

export function getRedirectAfterLogin(location, fallback = '/') {
  const stateRedirect = location?.state?.redirectTo;
  if (stateRedirect) return getSafeRedirectPath(stateRedirect, fallback);

  const queryRedirect = new URLSearchParams(location?.search || '').get(
    'redirect',
  );
  return getSafeRedirectPath(queryRedirect, fallback);
}
